/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Read_MoreInputs */

const en_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more`)
};

const zh_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读全文`)
};

/**
* | output |
* | --- |
* | "Read more" |
*
* @param {Blog_Read_MoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_read_more = /** @type {((inputs?: Blog_Read_MoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Read_MoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_read_more(inputs)
	return zh_blog_read_more(inputs)
});
export { blog_read_more as "blog.read_more" }